import {
    SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_PAID_UTM_SOURCES_SLUG,
    SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_WINDOW_OF_DAYS_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_ACTION_CODE_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_CAMPAIGN_CODE_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_POSTBACK_KEY_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_TARIFF_CODE_SLUG,
} from '../../constants';
import { useSettingsFactory } from './useSettingsFactory';

export const useSettingsAdmitad = () =>
    useSettingsFactory({
        isEnabled: { path: SETTINGS_INTEGRATIONS_ADMITAD_IS_ENABLED_SLUG },
        campaignCode: { path: SETTINGS_INTEGRATIONS_ADMITAD_CAMPAIGN_CODE_SLUG },
        postbackKey: { path: SETTINGS_INTEGRATIONS_ADMITAD_POSTBACK_KEY_SLUG },
        actionCode: { path: SETTINGS_INTEGRATIONS_ADMITAD_ACTION_CODE_SLUG },
        tariffCode: { path: SETTINGS_INTEGRATIONS_ADMITAD_TARIFF_CODE_SLUG },
        paidUtmSources: { path: SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_PAID_UTM_SOURCES_SLUG },
        windowOfDays: { path: SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_WINDOW_OF_DAYS_SLUG },
    });
